import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";

const InstallPrompt = ({ deferredPrompt, onDismiss }) => {
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    // Check if user is on a mobile device
    const checkIfMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // RegExp to detect mobile devices
      const mobileRegex =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;

      // Check if it's a mobile device and not an iPad with desktop mode
      const isMobile = mobileRegex.test(userAgent.toLowerCase());

      // Additional check for iOS devices that might request desktop site
      const isStandalone = window.navigator.standalone;
      const isTablet =
        /ipad/i.test(userAgent) ||
        (/macintosh/i.test(userAgent) && "ontouchend" in document);

      // Consider tablets as mobile for PWA install purposes
      setIsMobileDevice(isMobile || isTablet || isStandalone);
    };

    checkIfMobile();
  }, []);

  // If we're not on a mobile device or no deferred prompt exists, don't show anything
  if (!deferredPrompt || !isMobileDevice) return null;

  const handleInstall = async () => {
    try {
      // This is the key line - this actually shows the install prompt
      await deferredPrompt.prompt();

      // Get the user's choice
      const choiceResult = await deferredPrompt.userChoice;

      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the install prompt");
        localStorage.setItem("installAccepted", "true");
        if (window.gtag) {
          window.gtag("event", "pwa_install", {
            event_category: "PWA",
            event_label: "Install Accepted",
          });
        }
      } else {
        console.log("User dismissed the install prompt");
      }

      // Always call onDismiss regardless of outcome
      onDismiss && onDismiss();
    } catch (error) {
      console.error("Install prompt error:", error);
      onDismiss && onDismiss();
    }
  };

  const handleMaybeLater = () => {
    localStorage.setItem("lastMaybeLater", Date.now().toString());
    onDismiss && onDismiss();
  };

  const handleNeverShow = () => {
    localStorage.setItem("neverShowInstall", "true");
    onDismiss && onDismiss();
  };

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-sm px-4">
      <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
        <div className="flex items-center gap-3 mb-4">
          <img
            src="/eblogo_192.png"
            alt="ExpenseBot"
            className="w-12 h-12 rounded-xl"
          />
          <div>
            <h4 className="font-medium text-gray-900">Add Shortcut to Home</h4>
            <p className="text-sm text-gray-600">
              For faster uploads and offline access
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <button
            onClick={handleInstall}
            className="w-full px-4 py-3 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2"
          >
            <Download size={16} />
            Add Shortcut
          </button>
          <button
            onClick={handleMaybeLater}
            className="w-full px-4 py-3 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
          >
            Remind Me Later
          </button>
          <button
            onClick={handleNeverShow}
            className="text-sm text-gray-500 hover:text-gray-700 py-2"
          >
            Don't show again
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPrompt;
